if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          Shopify.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        const optionProduct = document.querySelector("#custom_option_product");
        if (optionProduct) {
          formData.set("id", optionProduct.value);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
           
            const parsedState = response;
            Shopify.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);

              console.log("elementToReplace", elementToReplace);
              console.log("parsedState", parsedState);

              elementToReplace.innerHTML = Shopify.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            document.querySelector("pack-composition")?.init();

            const cartDrawerOpener = document.querySelector(
              ".cart-drawer__opener"
            );
            cartDrawerOpener.classList.add("active");
            let overlay = document.querySelector(".cart-drawer__overlay");
            overlay.classList.add("active");
            let cartNotif = document.querySelector(
              ".header__nav--btn-cart .header__nav--notif"
            );
            cartNotif.classList.add("active");
            document.querySelector("body").classList.add('cart-drawer-open');


            launchCartUpsell();
            launchCartGiftCard();
            setupDiscounts();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );

            if (document.querySelector("pack-composition-v2")) {
              document.querySelector("pack-composition-v2").init();
              document.querySelectorAll("product-modal-pack").forEach((elem) => {
                elem.init();
              })
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
